import React, { Component } from 'react';

import GroupedJSONHelper from '../../../utils/grouped-json-helper';
import DetailedView      from './DetailedView';
import IPv4View          from './IPv4View';
import BasicView         from './BasicView';
import EntitySummary     from './EntitySummary';

class Group extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);

        this.state = {
            expanded: false
        };

        this.entityTypeMapping = {
            'PERSON': 'persons',
            'ORGANIZATION': 'orgs',
            'GEO': 'places',
            'THING': 'things'
        };

        this.geoLength = 0;
    }

    toggle() {
        this.setState({expanded: !this.state.expanded});
    }

    resultsCount (type) {
        var withDisambiguationResultsCount = Object.keys(this.props.results.withDisambiguationResults).length,
            withoutDisambiguationResultsCount = Object.keys(this.props.results.withoutDisambiguationResults).length;

        if (type != 'GEO') {
            return withDisambiguationResultsCount + withoutDisambiguationResultsCount;
        } else {
            return this.geoLength;
        }
    }

    allViews() {
        var self = this,
            lat,
            lon,
            allViews = [],
            nullText = [],
            nullObj = {},
            entityType = this.entityTypeMapping[/ORGANIZATION|PERSON|GEO|THING/.exec(this.props.type)],
            nulls = this.props.results.withDisambiguationResults[null];

        var results = Object.assign({}, this.props.results.withDisambiguationResults, this.props.results.withoutDisambiguationResults);

        const entitiesData = this.props.entitiesData;

        if (nulls) {

            // create unique entires for null entries
            for (var i = 0; i < nulls.length; i++) {
                var name = 'null' + i;
                // keep track of null geo titles and if it has already been counted
                //then do not include it in results, this minimizes duplicates

                if (nullText.indexOf(nulls[i].text) === -1) {
                    nullText.push(nulls[i].text);
                    nullObj[name] = [nulls[i]];
                }
            }

            for (var key in nullObj) {
                results[key] = nullObj[key];
            }
        }
        // remove original null object
        delete results[null];

        // this is the correct count for geo entities after manipulation above
        if (entityType === 'places') {
            this.geoLength = Object.keys(results).length;
        }

        // Create an array of all entities that we can sort
        var combined = Object.keys(results).map((id) => {
            return {
                id,
                'mentions': results[id]
            }
        })

        // Now sort the array by salience score (highest to lowest)
        combined.sort((a,b) => {
                if('salienceScore' in a.mentions[0].raw.entities[0] && a.mentions[0].raw.entities[0].salienceScore != null &&
                    'salienceScore' in b.mentions[0].raw.entities[0] && b.mentions[0].raw.entities[0].salienceScore != null) {
                    if (a.mentions[0].raw.entities[0].salienceScore > b.mentions[0].raw.entities[0].salienceScore) {
                        return -1;
                    } else if (a.mentions[0].raw.entities[0].salienceScore < b.mentions[0].raw.entities[0].salienceScore) {
                        return 1;
                    }
                return 0;
            }
            return 0;           
        })

        combined.forEach((entity) => {
            if (entity.id.startsWith('entity_')) {

                // Handle entities that are not disambiguated !!!

                var mentions = entity.mentions;
                var title = mentions[0].raw.entities[0].normalizedText;
                var label = 'Mentions of ' + title + ' (' + mentions.length + ')';
                var overallSentiment = mentions[0].raw.entities[0].overallSentiment || null;
                var salienceScore = 'salienceScore' in mentions[0].raw.entities[0] ? mentions[0].raw.entities[0].salienceScore : null;
    
                // Special handling of label for acronyms
                if ('attributes' in mentions[0].raw.entities[0]) {
                    let attributes = mentions[0].raw.entities[0].attributes;
                    if ('longForm' in attributes && 'shortForm' in attributes) {
                        label = 'Mentions of ' + attributes.longForm + ' (' + attributes.shortForm + ') (' + mentions.length + ')';
                    }
                }
    
                if (mentions[0].raw.entities[0].type == 'URI' || mentions[0].raw.entities[0].type == 'IPV4') {
                    allViews.push(<IPv4View entity={ mentions[0].raw.entities[0] }
                                    key={ entity.id + mentions[0].raw.entities[0].normalizedText}
                                    overallSentiment={overallSentiment} salienceScore={salienceScore}/>);
                }
                allViews.push(<BasicView key={ entity.id } mentions={ mentions } label={ label } 
                    overallSentiment={overallSentiment} title={ title } salienceScore={salienceScore}/>);

                if (mentions[0].raw.entities[0].entitySummary) {
                    allViews.push(<EntitySummary 
                        key={`es_${entity.id}`} 
                        label={title}
                        summary={mentions[0].raw.entities[0].entitySummary}></EntitySummary>
                    );
                }

            } else {

                // Handle entities that are disambiguated !!!

                var mentions = entity.mentions,
                title = mentions[0].raw.entities[0].normalizedText,
                disambiguationResults = mentions[0].raw.entities[0].disambiguationResults,
                overallSentiment = mentions[0].raw.entities[0].overallSentiment || null,
                salienceScore = 'salienceScore' in mentions[0].raw.entities[0] ? mentions[0].raw.entities[0].salienceScore : null,
                label = 'Mentions of ' + title + ' (' + mentions.length + ')';

                // Special handling of label for acronyms
                if ('attributes' in mentions[0].raw.entities[0]) {
                    let attributes = mentions[0].raw.entities[0].attributes;
                    if ('longForm' in attributes && 'shortForm' in attributes) {
                        label = 'Mentions of ' + attributes.longForm + ' (' + attributes.shortForm + ') (' + mentions.length + ')';
                    }
                }

                if (disambiguationResults) {
                    allViews.push(disambiguationResults.map(function (disambiguationResult) {

                        if (disambiguationResult.attributes !== undefined) {

                            var lat = 0.0;
                            var lon = 0.0;

                            if (disambiguationResult.attributes.location) {
                                lat = Math.round(disambiguationResult.attributes.location.latitude * 10000) / 10000;
                                lon = Math.round(disambiguationResult.attributes.location.longitude * 10000) / 10000;
                            }
                            
                            var label = title;
                            var id = disambiguationResult.id;

                            return <DetailedView 
                            getEntityData = {(entityID)=> {
                                if(entitiesData && entitiesData[entityID.toString()] !== undefined){
                                    return entitiesData[entityID];
                                }
                                return null;
                            }}
                            toggleShowingEntities={self.props.toggleShowingEntities}
                                disambiguationResult={disambiguationResult} page={self.props.page || 4} lat={lat}
                                lon={lon} key={ entity.id + id } label={ label } type={ entityType }
                                entityId={ id } overallSentiment={overallSentiment} salienceScore={salienceScore}/>;

                        } else if (overallSentiment) {

                            var label = title,
                            id = disambiguationResult.id;

                            return <DetailedView
                            getEntityData = {(entityID)=> {
                                if(entitiesData && entitiesData[entityID.toString()] !== undefined){
                                    return entitiesData[entityID];
                                }
                                return null;
                            }}
                            toggleShowingEntities={self.props.toggleShowingEntities}
                                disambiguationResult={disambiguationResult} page={self.props.page || 4} 
                                key={ entity.id + id } label={ label } type={ entityType }
                                entityId={ id } overallSentiment={overallSentiment} salienceScore={salienceScore}/>;
                        }
                    }));
                }

                allViews.push(<BasicView key={ entity.id } mentions={ mentions } label={ label } title={title}/>);

                if (mentions[0].raw.entities[0].entitySummary) {
                    allViews.push(<EntitySummary 
                        key={`es_${entity.id}`} 
                        label={title}
                        summary={mentions[0].raw.entities[0].entitySummary}></EntitySummary>
                    );
                }
            }
        })

        return allViews;
    }

    render () {
        var toggleClasses = 'fa group-toggle',
            allViews = this.allViews(),
            resultCount = this.resultsCount(this.props.type);

        if (this.state.expanded) {
            toggleClasses += ' fa-chevron-down';
        } else {
            toggleClasses += ' fa-chevron-right';
        }

        return <div className="group">
            <h2 className="group-title" onClick={ this.toggle }>
                { this.props.type.toLowerCase() } (<span className='results-count'>{ resultCount }</span>)
                <span className={toggleClasses}/>
            </h2>

            <div className={ this.state.expanded ? 'group-body expanded' : 'group-body' }>
                { allViews }
            </div>
        </div>;
    }
}

class GroupedJSONResults extends Component {
    constructor(props) {
        super(props);
        this.toggleShowingEntities = this.toggleShowingEntities.bind(this);

        this.state = {groupedResults: {}};
    }

    componentDidMount(){
        this.setState({
            groupedResults: GroupedJSONHelper.groupResults(this.props.groups)
        });
    }

    toggleShowingEntities (parentId) {
        this.setState({
            groupedResults: GroupedJSONHelper.groupResultsToggle(this.state.groupedResults, parentId)
        });
    }

    render () {
        const entitiesData = this.props.entitiesData
        var self = this;
        return (
            <aside>
                <section>
                    { GroupedJSONHelper.mapGroups(function (type, results, idx) {
                            return <Group
                                entitiesData = {entitiesData}
                                toggleShowingEntities={self.toggleShowingEntities}
                                page={self.props.page || 4}
                                hidden={true}
                                key={ idx }
                                results={ results}
                                type={ type }/>;
                        }, self.state.groupedResults)
                    }
                </section>
            </aside>
        );
    }
}

export default GroupedJSONResults;


